import { formatPhoneNumber } from 'utils';
import template from './delivery_method.template.html';

angular.module('bb.appointments').directive('deliveryMethod', () => {
  return {
    restrict: 'E',
    scope: {
      notify: '=',
      email: '=',
      phone: '=',
      text: '=',
      auth: '<',
      isConcierge: '<',
      hideToggle: '=',
      features: '=',
    },
    controller: DeliveryMethodController,
    bindToController: true,
    controllerAs: 'vm',
    template,
  };
});

DeliveryMethodController.$inject = ['$scope'];
function DeliveryMethodController($scope) {
  const vm = this;

  vm.formatPhoneNumber = formatPhoneNumber;

  function shouldOverrideDeliveryMethod(choice) {
    return !(
      (choice === 'emailAndText' && vm.notify.email && vm.notify.text) ||
      (choice === 'email' && vm.notify.email && !vm.notify.text) ||
      (choice === 'text' && vm.notify.text && !vm.notify.email) ||
      (choice === 'office' && vm.notify.office)
    );
  }

  vm.notifyBy = function (choice) {
    if (shouldOverrideDeliveryMethod(choice)) {
      swal(
        {
          title: 'Overriding Delivery Method',
          text: 'Are you sure you want to override the delivery method?',
          type: 'warning',
          confirmButtonColor: '#f48042',
          showCancelButton: true,
          confirmButtonText: 'Yes, Override',
          cancelButtonText: 'Cancel',
        },
        function () {
          vm.notify.email = vm.notify.text = vm.notify.office = false;
          if (choice === 'emailAndText') {
            vm.notify.email = true;
            vm.notify.text = true;
          } else {
            vm.notify[choice] = true;
          }
          $scope.$apply();
        },
      );
    }
  };
}
